// extracted by mini-css-extract-plugin
export default {"headerBannerMovil":"HeaderBanner_headerBannerMovil__XfHZP","headerBannerDesktop":"HeaderBanner_headerBannerDesktop__SShtO","img":"HeaderBanner_img__ZLf3P"};